/**
 * Generated by orval 🍺
 * Do not edit manually.
 * QPM API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation
} from '@tanstack/react-query';
import type {
  MutationFunction,
  UseMutationOptions,
  UseMutationResult
} from '@tanstack/react-query';

import type {
  HTTPValidationError,
  ResendVerification200,
  ResendVerificationRequest
} from '../../models';

import { customMutator } from '../../api.ts';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Resend the email verification code.
 *
 * Rate-limited (per IP) to blunt verification-email spam / user-id probing.
 * @summary Resend Verification
 */
export const resendVerification = (
    resendVerificationRequest: ResendVerificationRequest,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {


      return customMutator<ResendVerification200>(
      {url: `/auth/resend-verification`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: resendVerificationRequest, signal
    },
      options);
    }




export const getResendVerificationMutationKey = () => ['resendVerification'] as const;

export const getResendVerificationMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resendVerification>>, TError,ResendVerificationMutationVariables, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof resendVerification>>, TError,ResendVerificationMutationVariables, TContext> => {

const mutationKey = getResendVerificationMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resendVerification>>, ResendVerificationMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  resendVerification(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResendVerificationMutationResult = NonNullable<Awaited<ReturnType<typeof resendVerification>>>
    export type ResendVerificationMutationBody = ResendVerificationRequest
    export type ResendVerificationMutationError = HTTPValidationError
    export type ResendVerificationMutationVariables = {data: ResendVerificationRequest}

    /**
 * @summary Resend Verification
 */
export const useResendVerification = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resendVerification>>, TError,ResendVerificationMutationVariables, TContext>, request?: SecondParameter<typeof customMutator>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof resendVerification>>,
        TError,
        ResendVerificationMutationVariables,
        TContext
      > => {
      return useMutation(getResendVerificationMutationOptions(options));
    }
